import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import BlackboardWriterForm from '../forms/blackboard-writer-form';
import { blackboardWriterValidationSchema } from '../schema/blackboardWriter.js';

export default function BlackboardWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Blackboard Writer Node Details',
        altText: 'Blackboard Writer Node',
        defaultLabel: 'Blackboard Writer Node',
      }}
    >
      <CommonNode
        FormComponent={BlackboardWriterForm}
        schemaResolver={blackboardWriterValidationSchema}
      />
    </NodeProvider>
  );
}
